var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('event-list-component',{attrs:{"eventType":'event'}}),_c('event-normal-filter-modal'),_c('non-button-update-sort-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }